import {
    GET_COPO_BASIC_INFO,
    GET_COPO_BASIC_INFO_FAILURE,
    GET_COPO_BASIC_INFO_SUCCESS,
    SET_COPO_BASIC_INFO_FORM_DATA,
    SET_COPO_GENERAL_DETAILS_DATA,
    RESET_COPO_DATA
} from "./actionTypes";

export const getCopoBasicInfo = (id: any) => ({
    type: GET_COPO_BASIC_INFO,
    payload: id
});

export const getCopoBasicInfoSuccess = (data: any) => ({
    type: GET_COPO_BASIC_INFO_SUCCESS,
    payload: data
});

export const getCopoBasicInfoFailure = (error: any) => ({
    type: GET_COPO_BASIC_INFO_FAILURE,
    payload: error
});

export const setCopoBasicInfoFormData = (data: any) => ({
    type: SET_COPO_BASIC_INFO_FORM_DATA,
    payload: data
});

export const setCopoGeneralDetailsData = (data: any) => ({
    type: SET_COPO_GENERAL_DETAILS_DATA,
    payload: data
});

export const resetCopoData = () => ({
    type: RESET_COPO_DATA
});
